<div class="full-width p-2">
  <div class="empty-row flex-center">
    <mat-icon svgIcon="add" class="icon-12"></mat-icon>
  </div>
</div>
